import TokenService from "../utils/TokenService";

/**
 * Shared 2FA login flow for Login/Register.
 * Uses token flags to route users to the dedicated 2FA pages.
 *
 * @param {Object} options
 * @param {function(string, string, string)} options.displayAlert - (severity, title, message)
 * @param {function()} options.logoutUser - app context logout (clears tokens, calls logout API, updates state)
 * @param {function(Object, string, string)} options.onLoginComplete - (data, username, loginProvider) called with token data, email, and login provider ("Google" | "Facebook" | "Wallist") when login is complete
 * @param {function()} [options.onRedirectToVerify2FA] - called when token has tfa="p"; typically navigate("/verify-2fa")
 * @returns {{ check2FAAndProceed: function(Object, string, string): Promise<void> }}
 */
export default function useTwoFactorLogin({ displayAlert, logoutUser, onLoginComplete, onRedirectToVerify2FA }) {
    const check2FAAndProceed = async (data, username, loginProvider = "Wallist") => {
        try {
            TokenService.setAccessToken(data.userAccessToken);
            TokenService.setRefreshToken(data.userRefreshToken);
            if (TokenService.isPending2fa() && onRedirectToVerify2FA) {
                onRedirectToVerify2FA();
                return;
            }
            onLoginComplete(data, username, loginProvider);
        } catch (error) {
            logoutUser();
            displayAlert(
                "error",
                "Verification Error",
                "We couldn't verify your sign-in. Please try again."
            );
        }
    };

    return { check2FAAndProceed };
}
